import { openChatFromResponse } from 'modules/ChatV2/api/routes';

import { buildChatUrl } from './buildChatUrl';

export interface TutorBulletinChatSource {
  id: number;
  id_user?: number | null;
  my_bulletin_response_id?: number | null;
  pair_chat_id?: number | null;
  pair_room_id?: string | null;
}

/** Открыть чат репетитора по заявке: всегда через open_from_response при наличии отклика. */
export async function resolveTutorChatUrl(
  bulletin: TutorBulletinChatSource,
): Promise<string> {
  if (bulletin.pair_chat_id && bulletin.pair_room_id) {
    return buildChatUrl({
      chatId: bulletin.pair_chat_id,
      roomId: bulletin.pair_room_id,
      bulletinId: bulletin.id,
      userId: bulletin.id_user ?? undefined,
      role: 'tutor',
    });
  }

  if (bulletin.my_bulletin_response_id) {
    const opened = await openChatFromResponse(bulletin.my_bulletin_response_id);
    return buildChatUrl({
      chatId: opened.chat_id,
      roomId: opened.room_id,
      bulletinId: opened.bulletin_id,
      userId: bulletin.id_user ?? undefined,
      role: 'tutor',
    });
  }

  return '/teacher/chat';
}
